import { Button, Center, Checkbox, Input, Select, Textarea, VStack } from "@chakra-ui/react";
import React from "react";
import { PostData, PostTypes } from "../clients/data-service";
import { createPost, updatePost } from "../clients/posts-client";
import SavingModal from "./SavingModal";
import { withRouter } from "./withRouter";

class PostEditorState
{
    title?: string
    body?: string
    type?: string
    active?: boolean
    savingInProgress: boolean
}

export class PostEditorProps
{
    postId: string|undefined
    postData: PostData|undefined
}

class PostEditor1 extends React.Component<PostEditorProps,PostEditorState> {
    constructor(props) {
        super(props);
        this.state = {
            savingInProgress: false
        };

        this.save = this.save.bind(this);
    }

    static resolveCurrentPostState(ref: PostEditor1) : PostData {
        return {
            title: ref.state.title ?? ref.props.postData?.title ?? "",
            body: ref.state.body ?? ref.props.postData?.body ?? "",
            type: ref.state.type ?? ref.props.postData?.type ?? "News",
            active: ref.state.active ?? (ref.props.postData?.active ?? false),
        }
    }

    save = async function() {
        const elRef = this;
        const stateToSave = PostEditor1.resolveCurrentPostState(elRef);

        elRef.setState({savingInProgress: true});
        try {
            if (elRef.props.postId) {
                const updateResult = await updatePost(elRef.props.postId, stateToSave);
            } else {
                const postId = await createPost(stateToSave);
                elRef.props.navigate("/manage-posts/");
            }
        } catch (error) {
            
        }
        //console.log(PostEditor.resolveCurrentPostState(elRef));
        elRef.setState({savingInProgress: false});
    }

    render() {

        const elRef = this;
        const post = PostEditor1.resolveCurrentPostState(elRef);

        return (<>
            <Center >
                <VStack  w={'100%'}>
                    <Input type="text" name="title" maxW={1000} value={post.title} onChange={event => this.setState({title: event.target.value})}/>
                    <Select name="postType" maxW={1000}  value={post.type}  onChange={event => this.setState({type: event.target.value})}>
                                {PostTypes().map(postType => <option key={postType.Key} value={postType.Key}>{postType.Selection}</option>)}
                    </Select>
                    
                    <Textarea maxW={1000} minH={600} value={post.body} onChange={event => this.setState({body: event.target.value})}/>
                    <Checkbox type="checkbox" maxW={1000} name="postLive" isChecked={post.active} onChange={event => this.setState({active: event.target.checked})}>
                        Post Is Live
                    </Checkbox>
                    <Button w={"30%"} onClick={this.save} colorScheme="green">Save</Button>
                </VStack>
            </Center>
            <SavingModal isOpen={this.state.savingInProgress}/>
        </>);
    }
}

export const PostEditor = withRouter(PostEditor1);
